import React from 'react';

import { ProducerTeaser } from '/components/producer-teaser/components';

const RelatedProducersCarouselHit = ({ hit }) => (
    <ProducerTeaser producer={hit} />
);

export { RelatedProducersCarouselHit };
